import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-966eba30")

_pushScopeId("data-v-966eba30")
const _hoisted_1 = { class: "condition-blogs" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "blogs-box" }
_popScopeId()

import BlogList from "@/components/BlogList.vue";
import Aside from "@/components/Aside.vue";
import { reactive, ref } from "vue";
import { useGetRequest, useLog, usePostRequest } from "@/hooks";
import { useRoute, useRouter } from "vue-router";
import { AssertGoodResponse } from "@/util/GlobalUtil";
import { BlogConditionStrategies } from "@/interfaces";


export default _defineComponent({
  expose: [],
  setup(__props) {

/* eslint-disable */
const l = useLog();
const { query } = useRoute();
const state = reactive({
  isLoading: true,
  pagingParams: {
    pageSize: 10,
    currentPage: 1,
    total: 100
  },
  blogs: []
});

// l('从上一页调过来并携带来的参数:', query)
const { conditionStrategy, value } = query; // 从query中接收参数, 前者是策略名,后者是categoryid或tagId
const msg = ref<string>("");
// 由于条件查询是需要从其他页面携带params跳过来, 所以如果没有params里面的参数,就不能显示该页面.所以要调回上一个页面
if (!conditionStrategy || !value) {
  useRouter().go(-1);
}

const getBlogInfo = () => {
  state.isLoading = true;
  // 不用的条件策略, 调用不同的接口, 也显示不同的msg
  switch (conditionStrategy) {
    // 按类型
    case BlogConditionStrategies.BY_CATEGORY: {
      // 当前类型信息
      useGetRequest(`/api/category/${value}`).then(res => {
        AssertGoodResponse(res);
        msg.value = `${res.data.data.categoryName}类下的文章:`;
      });
      // 博客信息
      usePostRequest(`/api/blog/with_category/${value}`, state.pagingParams)
        .then(res => {
          AssertGoodResponse(res);
          state.blogs = res.data.data.collection;
          state.pagingParams.pageSize = res.data.data.pageSize;
          state.pagingParams.currentPage = res.data.data.currentPage;
          state.pagingParams.total = res.data.data.total;
        })
        .finally(() => {
          state.isLoading = false;
        });
      break;
    }
    // 按标签
    case BlogConditionStrategies.BY_TAG: {
      // 获取当前标签信息
      useGetRequest(`/api/tag/${value}`).then(res => {
        AssertGoodResponse(res);
        msg.value = `#${res.data.data.tagName}标签下的文章:`;
      });
      // 博客信息
      usePostRequest(`/api/blog/with_tag/${value}`, state.pagingParams)
        .then(res => {
          AssertGoodResponse(res);
          state.blogs = res.data.data.collection;
          state.pagingParams.pageSize = res.data.data.pageSize;
          state.pagingParams.currentPage = res.data.data.currentPage;
          state.pagingParams.total = res.data.data.total;
        })
        .finally(() => {
          state.isLoading = false;
        });
      break;
    }
  }
};

const currentPageChange = (newCurrentPage: number) => {
  state.pagingParams.currentPage = newCurrentPage;
  getBlogInfo();
};

getBlogInfo();

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", _hoisted_2, _toDisplayString(msg.value), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_el_row, null, {
        default: _withId(() => [
          _createVNode(_component_el_col, { lg: 16 }, {
            default: _withId(() => [
              _createVNode(BlogList, {
                loading: _unref(state).isLoading,
                blogs: _unref(state).blogs,
                pagingParams: _unref(state).pagingParams,
                onCurrentPageChange: currentPageChange
              }, null, 8, ["loading", "blogs", "pagingParams"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { lg: 7 }, {
            default: _withId(() => [
              _createVNode(Aside)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})